import { NavLink } from 'react-router-dom';
import { useDataContext } from 'context/DataStoreContext';
import { generalStyle } from 'helper/Style';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import H2 from 'component/part/H2';
import List from 'component/part/List';

const partnerIndexes = [
  { label: '業者名', key: 'name' },
  { label: '日給' },
];

const PartnerList: React.FC = () => {
  const { state } = useDataContext();
  const { list = [] } = state?.partner || {};

return <Layout>
    <BackLink link='/' label='トップ'></BackLink>
    <H2>協力業者一覧</H2>
    <div css={generalStyle.form}>
      <List type='partner' indexes={partnerIndexes} css={generalStyle.list(2, { right: [2] })}>
        {list.map((partner, index) => (
          <div css={generalStyle.listRow} key={index}>
            <div>
              <NavLink to={`/partner/${partner.id}`} css={generalStyle.link}>{partner.name}</NavLink>
            </div>
            <div>{partner.unitSalary ? `\xA5${partner.unitSalary.toLocaleString()}` : 'ー'}</div>
          </div>
        ))}
      </List>
      <div css={generalStyle.formRow}>
        <NavLink to='/partner/create' css={generalStyle.button()}>新規登録</NavLink>
      </div>
    </div>
  </Layout>;
};

export default PartnerList;
